
















































































































// vue
import { computed, defineComponent, ref, Ref } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Select2 } from '@/components/form'

// hooks
import { useHeadquarter, useEmployeesOp } from '@/hooks'

// libs
import { dateLibs } from '@/utils'
import moment from 'moment'

// constants
import {
    optionsWorkType,
    optionsWorkCategory,
    APP_URL_API,
    optionsTelecredito
} from '@/constants'

export default defineComponent({
  name: 'Telecredito',
  components: {
    PageHeader,
    Select2
  },
  setup () {
    const title = 'Telecrédito'
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Telecrédito',
        active: true
      }
    ]
    const currentDate = moment()
    const year: Ref<number> = ref(currentDate.year())
    const month: Ref<number> = ref(currentDate.month() - 1)
    const fortnight: Ref<number> = ref(1)
    const headquarter: Ref<number> = ref(0)
    const telecredito: Ref<number> = ref(0)
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault
    const workType: Ref<number> = ref(0)
    const workCategory: Ref<number> = ref(0)
    const employee: Ref<number> = ref(0)

    const { employeesOp, getEmployees, loadingEmployees } = useEmployeesOp()
    getEmployees()

    const urlReport = computed(() => {
      return `${APP_URL_API}reports/telecredito/1?year=${year.value}&month=${month.value}&fortnight=${fortnight.value}&workCategory=${workCategory.value}&employees=${employee.value}&headquarter=${headquarter.value}&telecredito=${telecredito.value}`
    })

    const urlexport = computed(() => {
      return `${APP_URL_API}reports/telecredito/2?year=${year.value}&month=${month.value}&fortnight=${fortnight.value}&workCategory=${workCategory.value}&employees=${employee.value}&headquarter=${headquarter.value}&telecredito=${telecredito.value}`
    })

    const { headquartersSelectOptions, getHeadquatersActivated } = useHeadquarter()
    getHeadquatersActivated()

    return {
      title,
      breadcrumbs,
      year,
      month,
      fortnight,
      years,
      months,
      fortnights,
      optionsWorkType,
      optionsWorkCategory,
      optionsTelecredito,
      workType,
      telecredito,
      workCategory,
      employeesOp,
      loadingEmployees,
      employee,
      urlReport,
      urlexport,
      headquarter,
      headquartersSelectOptions
    }
  }
})
